import { userConstants } from './constantData';

export const SETTINGS_DATA = {
  settings: {
    page_view: {
      hash: 'p-043.007.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    log_out: {
      hash: 'e-043.007.001.000.000.073',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    terms_and_conditions: {
      hash: 'e-043.007.001.000.000.087',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    privacy_policy: {
      hash: 'e-043.007.001.000.000.078',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
  log_out_confirmation: {
    confirm: {
      hash: 'e-043.026.001.000.000.008',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    cancel: {
      hash: 'e-043.026.001.000.000.051',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
  privacy_policy: {
    page_view: {
      hash: 'p-043.054.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
  },
  terms_and_conditions: {
    page_view: {
      hash: 'p-043.053.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
  },
};
